/**
 * API Configuration
 * Centralizes API URL management with support for Lambda Function URLs and ALB URLs
 */

type ApiType = 'lf' | 'alb';

interface ApiConfig {
  baseURL: string;
  privateBaseURL: string;
  credentialsURL: string;
  apiType: ApiType;
}

// ============================================
// GLOBAL CONFIGURATION VARIABLES
// ============================================
// Configure these values directly to control API behavior

/**
 * Update ALB Url based on AWS Account
 * If deployment is on AWS GH Account, set -> https://api.r2c.ghdev.toyota.com
 * else if deployment is on AWS VLS Account, set -> https://api.r2c.one.uttmsdev.toyota.com
 */

let GLOBAL_API_TYPE: ApiType = 'alb';  // 'function' or 'alb'

let GLOBAL_ALB_URL: string = 'https://api.r2c.ghdev.toyota.com';
let GLOBAL_PRIVATE_ALB_URL: string = 'https://api.r2c.ghdev.toyota.com';

let GLOBAL_LAMBDA_FUNCTION_URL: string = 'https://abkyxpy4zfvflcn3t5i7nntptm0yosmn.lambda-url.us-east-1.on.aws';
let GLOBAL_PRIVATE_LAMBDA_URL: string = 'https://abkyxpy4zfvflcn3t5i7nntptm0yosmn.lambda-url.us-east-1.on.aws';

let GLOBAL_CREDENTIALS_URL: string = 'https://ytk481p2oi.execute-api.us-east-1.amazonaws.com/dev/getCreds';

// ============================================

/**
 * Get the base URL based on API type
 */
const getBaseURL = (): string => {
  if (GLOBAL_API_TYPE === 'alb') {
    return `${GLOBAL_ALB_URL}/api`;
  } else {
    return `${GLOBAL_LAMBDA_FUNCTION_URL}/api`;
  }
};

/**
 * Get the private base URL based on API type
 */
const getPrivateBaseURL = (): string => {
  if (GLOBAL_API_TYPE === 'alb') {
    return `${GLOBAL_PRIVATE_ALB_URL}`;
  } else {
    return `${GLOBAL_PRIVATE_LAMBDA_URL}/`;
  }
};

/**
 * Get the credentials URL
 */
const getCredentialsURL = (): string => {
  return GLOBAL_CREDENTIALS_URL;
};

/**
 * API Configuration object
 */
const apiConfig: ApiConfig = {
  baseURL: getBaseURL(),
  privateBaseURL: getPrivateBaseURL(),
  credentialsURL: getCredentialsURL(),
  apiType: GLOBAL_API_TYPE,
};

export default apiConfig;